import { Stack, Typography } from "@mui/material";
import { APP_COLORS } from "../../enums";
import SegmentedProgressBar from "./segmented-progress-bar";

interface LabeledProgressBarProps {
  label: string;
  value: number;
  filledColor?: string;
  emptyColor?: string;
  labelVariant?: string;
}

function LabeledProgressBar({
  label,
  value,
  filledColor,
  emptyColor,
  labelVariant = "small-ibmPlexMono",
}: LabeledProgressBarProps) {
  return (
    <Stack gap={1}>
      <Typography variant={labelVariant as any} color={APP_COLORS.textMedium}>
        {label}
      </Typography>
      <SegmentedProgressBar
        value={value}
        filledColor={filledColor}
        emptyColor={emptyColor}
      />
    </Stack>
  );
}

export default LabeledProgressBar;
